import { URL_STATE_PREFIX, useScopedUrlState } from 'features/scoped_url_state'

import { routes } from '../routes'

export const useRightRail = () => useScopedUrlState(URL_STATE_PREFIX.RIGHT_RAIL, routes)
